import { ResolveResource } from './utils'
import Factory from './utils/Factory'
const resource = ResolveResource(__filename)
import fetch from '@/fetch'

export default new Factory(resource, {
  addon(payload = {}) {
    let { addon, state, page, reason } = payload

    const params = new URLSearchParams()
    if (reason) params.append('reason', reason)

    return fetch(`/api/page/${page}/addon/${state ? 'enable' : 'disable'}/${addon}?` + params.toString())
  },
  relationMeta(id) {
    return fetch(`/api/page/${id}/relation-meta`, { method: 'GET' }).then(res => res.json())
  },
  archive(id) {
    return fetch(`/api/page/${id}/archive`, { method: 'POST' })
  },
})
